import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import cometeColors from '../../theme/cometeColors';

const IconCometeClockings = ({ themed = false, sx }) => {
  const theme = useTheme();
  const { main, dark } = theme.palette.primary;
  const { main: cometeBlue, secondary: cometeYellow, secondaryLight: cometeYellowLight } = cometeColors;
  const cometeShape = themed ? alpha(main, 0.6) : cometeBlue;
  const gradientStart = themed ? alpha(dark, 0.6) : cometeYellowLight;
  const gradientEnd = themed ? alpha(dark, 0.6) : cometeYellow;

  return (
    <Box component="span" display="block" sx={{ width: 40, height: 40, ...sx }}>
      <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M766.07 335.51L31 31L350.59 772.7C403.86 894.5 521.04 970.63 651.01 968.46C829.98 966.29 970.6 816.2 968.47 633.5C966.34 503 887.51 385.54 766.06 335.52L766.07 335.51Z"
          fill={cometeShape}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M853.75 511.75H481.75C478.99 511.75 476.75 513.99 476.75 516.75V880.98C522.73 914.95 578.26 934.83 637.27 936.75H656.53C736.77 934.4 808.11 898.96 858.75 843.42V516.75C858.75 513.99 856.51 511.75 853.75 511.75ZM663.81 826.69C599.09 826.69 546.62 773.78 546.62 708.52C546.62 643.26 599.09 590.35 663.81 590.35C728.53 590.35 781 643.26 781 708.52C781 773.78 728.53 826.69 663.81 826.69Z"
          fill="url(#yellow_gradient)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M804.75 398.75C804.75 395.99 802.51 393.75 799.75 393.75H535.75C532.99 393.75 530.75 395.99 530.75 398.75V471.75H804.75V398.75Z"
          fill="url(#yellow_gradient)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M732.62 700.64H671.62V615.48C671.62 614.65 670.95 613.98 670.12 613.98H649.68C648.85 613.98 648.18 614.65 648.18 615.48V702.1C648.18 702.1 648.18 702.13 648.18 702.14V722.77C648.18 723.6 648.85 724.27 649.68 724.27H732.62C733.45 724.27 734.12 723.6 734.12 722.77V702.14C734.12 701.31 733.45 700.64 732.62 700.64Z"
          fill="url(#yellow_gradient)"
        />
        <defs>
          <radialGradient
            id="yellow_gradient"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(525.19 554.21) scale(393.27 393.27)"
          >
            <stop stopColor={gradientStart} />
            <stop offset="1" stopColor={gradientEnd} />
          </radialGradient>
        </defs>
      </svg>
    </Box>
  );
};
IconCometeClockings.propTypes = {
  sx: PropTypes.object,
  themed: PropTypes.bool
};

export default IconCometeClockings;
